import * as React from "react";
import "./styles.scss";
import {VeBoxModal} from "../../../../../components/modal/VeBoxModal";
import {VeBoxCard} from "../../../../../components/card/VeBoxCard";
import {FormCardFooter} from "../../../../common";
import {FindEquipmentTable} from "../FindEquipmentTable";
import {FindEquipmentFilters} from "../FindEquipmentFilters";
import {FindEquipmentContext} from "../../providers/FindEquipmentProvider";
import {AppTranslations} from "../../../../../components/Utils/translations/AppTranslations";
import {capitalizeFirstLetter} from "../../../../../ReadAndWrite/ReadAndWrite/utils";
import {Display} from "../../../../../components/Display";
import {ErrorDialog} from "../../../../../equipment/details/new_settings/dialog/ErrorDialog";

declare var AppTranslations: AppTranslations;

type FindEquipmentModalProps = {
    closeDialog: () => void;
};

export const FindEquipmentModal: React.FC<FindEquipmentModalProps> = ({
                                                                          closeDialog,
                                                                      }) => {
    const {
        applyFilterAndSearch,
        equipmentList,
        equipmentGuidsList,
        removeAllFilters,
        addComponentsToCensus,
        censusWithNewEntities,
        updateSelectedEquipment,
        removeCensusErrors
    } = React.useContext(FindEquipmentContext);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [addingComponents, setAddingComponents] =
        React.useState<boolean>(false);
    React.useEffect(() => {
        setIsLoading(equipmentList?.isFetching || equipmentGuidsList?.isLoading);
    }, [equipmentList?.isFetching, equipmentGuidsList?.isLoading]);

    const addEntriesToCensus = () => {
        setAddingComponents(true);
        addComponentsToCensus();
    };

    React.useEffect(() => {
        if (!censusWithNewEntities?.isLoading && addingComponents) {
            setAddingComponents(false);
            closeDialog();
        }
    }, [censusWithNewEntities?.isLoading]);

    const errorMessage = React.useMemo(() => {
        if (censusWithNewEntities?.error) {
            return <div className={"flx-col"} style={{width: "500px", height: "100px"}}>
                <p>{AppTranslations.massiveActions.censusCooler.notAbleToAddEquipment}</p>
                <p> {AppTranslations.errorMessages.tryAgainLaterMessage}</p>
            </div>;
        }
        return undefined
    }, [censusWithNewEntities?.error]);


    React.useEffect(() => {
        return () => {
            updateSelectedEquipment([]);
        }
    }, [])

    return (
        <VeBoxModal.Backdrop>
            <VeBoxModal>
                <VeBoxModal.Section style={{padding: 0}}>
                    <Display isVisible={errorMessage}>
                        <ErrorDialog onOk={removeCensusErrors} description={errorMessage}/>
                    </Display>
                    <Display isVisible={!errorMessage}>
                        <VeBoxCard className={"find-equipment-card"}>
                            <FindEquipmentFilters/>
                            <div className={"filter-footer"}>
                                <FormCardFooter
                                    onReset={removeAllFilters}
                                    onNext={applyFilterAndSearch}
                                    nextButtonText={capitalizeFirstLetter(
                                        AppTranslations.massiveActions.massiveActionsCommon
                                            .searchCode,
                                    )}
                                    restButtonText={capitalizeFirstLetter(
                                        AppTranslations.genericWords.removeFilter,
                                    )}
                                    loading={isLoading}
                                    loadable={true}
                                    disabled={isLoading || addingComponents}
                                    disabledCancel={isLoading || addingComponents}
                                />
                            </div>
                            <FindEquipmentTable/>
                            <div className={"equipment-list-footer"}>
                                <FormCardFooter
                                    onReset={() => closeDialog()}
                                    onNext={addEntriesToCensus}
                                    restButtonText={capitalizeFirstLetter(
                                        AppTranslations.genericWords.cancel,
                                    )}
                                    nextButtonText={capitalizeFirstLetter(
                                        AppTranslations.genericWords.add,
                                    )}
                                    loadable={true}
                                    disabled={
                                        equipmentList?.flattenedData?.length === 0 || isLoading
                                    }
                                    disabledCancel={isLoading || addingComponents}
                                    loading={addingComponents}
                                />
                            </div>
                        </VeBoxCard>
                    </Display>
                </VeBoxModal.Section>
            </VeBoxModal>
        </VeBoxModal.Backdrop>
    );
};
